export default class Convert {
	public static numberToPrice = (price: number | null | undefined): string => {
		if (price) {
			return `${String(Number(price).toFixed(2)).replace(".", ",")}€`;
		}
		return "0,00€";
	};
}
